import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Table, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {fullDate, shortDate} from '../../../common/constants/datesFormat';
import {dealerOrdersStatus as status} from '../../../common/dictionaries/classification';
import {getOrderStatusName, getOrderTypeName, transportOptions} from '../common/utils';
import {SPECIAL_TYPE} from '../../constants';
import DeleteIcon from '../common/deleteIcon';
import PartInfo from '../common/partInfo';
import Comment from './comment';
import Agency from './agency';

class OrderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showBilling': false,
      'showSubstitutes': false,
    };
    this.handleShowClick = this.handleShowClick.bind(this);
    this.handleShowSubstitutesClick = this.handleShowSubstitutesClick.bind(this);
    this.handleTrackClick = this.handleTrackClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.renderLoading = this.renderLoading.bind(this);
  }

  handleShowClick() {
    this.setState({'showBilling': !this.state.showBilling});
  }

  handleShowSubstitutesClick() {
    this.setState({'showSubstitutes': !this.state.showSubstitutes});
  }

  handleDeleteClick() {
    const {element} = this.props;
    this.props.deleteDealerOrder(element);
  }

  handleTrackClick() {
    const {element} = this.props;
    this.props.selectOrderForTrackingSchedule(element.orderSequence);
  }

  getDisabledStatus() {
    const {element} = this.props;
    const disabledStatus = [status.rejected, status.billed];

    if (element.orderType === SPECIAL_TYPE) {
      return [...disabledStatus, status.entered, status.denied, status.removed].includes(element.status);
    }

    return disabledStatus.includes(element.status);
  }

  renderBilling() {
    const {element} = this.props;
    const {orderDetail} = element;

    if (!this.state.showBilling || !orderDetail.length) {
      return null;
    }

    return (
      <Table.Row>
        <Table.Cell colSpan='100%'>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Cantidad Reservada</Table.HeaderCell>
                <Table.HeaderCell>Pedido Proveedor</Table.HeaderCell>
                <Table.HeaderCell>Factura Proveedor</Table.HeaderCell>
                <Table.HeaderCell>ETA Estandar</Table.HeaderCell>
                <Table.HeaderCell>ETA Actualizada</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.renderBillingDetail(element.orderDetail)}</Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
    );
  }

  renderBillingDetail(detail = []) {
    return detail.map((reservation, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell>{reservation.reserveQuantity}</Table.Cell>
          <Table.Cell>{reservation.orderToProvider}</Table.Cell>
          <Table.Cell>{reservation.billOrder}</Table.Cell>
          <Table.Cell>{this.renderArriveDate(reservation.arrivalDate)}</Table.Cell>
          <Table.Cell>{this.renderArriveDate(reservation.etdDate)}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderSubstituteIcon() {
    const {element} = this.props;

    if (!element.substitutedOrders || !element.substitutedOrders.length) {
      return null;
    }

    const iconName = this.state.showSubstitutes ? 'minus circle' : 'plus circle';

    return (
      <Icon
        link
        size='small'
        color='orange'
        name={iconName}
        title='Ver códigos sustituidos'
        style={{'verticalAlign': 'middle', 'marginLeft': '6px'}}
        onClick={this.handleShowSubstitutesClick}
      />
    );
  }

  renderSubstituteDetail() {
    const {element} = this.props;

    if (!this.state.showSubstitutes || !element.substitutedOrders || !element.substitutedOrders.length) {
      return null;
    }

    return (
      <Table.Row>
        <Table.Cell colSpan='100%'>
          <Table className='invoice-table'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Código Solicitado</Table.HeaderCell>
                <Table.HeaderCell>Estado</Table.HeaderCell>
                <Table.HeaderCell>Observaciones</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {element.substitutedOrders.map((sub, i) => (
                <Table.Row key={i}>
                  <Table.Cell>{sub.partCode}</Table.Cell>
                  <Table.Cell>NEGADO</Table.Cell>
                  <Table.Cell>{`Sustituido por ${sub.substituteCode}`}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
    );
  }

  renderArriveDate(value) {
    if (!value) {
      return null;
    }

    return moment(value).format(shortDate);
  }

  renderShowIcon(detail = [], orderStatus) {
    if (!detail.length || orderStatus === status.billed) {
      return null;
    }

    const iconName = this.state.showBilling ? 'minus circle' : 'plus circle';

    return <Icon link name={iconName} color='blue' size='large' onClick={this.handleShowClick} />;
  }

  renderTrackingIcon(order) {
    if (order.orderType !== SPECIAL_TYPE || order.status === status.entered || order.status === status.denied) {
      return null;
    }

    return <Icon link name='history' color='blue' size='large' onClick={this.handleTrackClick} />;
  }

  renderLoading() {
    return (
      <div style={{'display': 'flex', 'justifyContent': 'center', 'alignItems': 'center'}}>
        <Icon loading name='spinner' size='large' color='grey' />
      </div>
    );
  }

  render() {
    const {element} = this.props;

    return (
      <React.Fragment>
        <Table.Row
          negative={
            !!element.isDelayed ||
            (element.orderType === SPECIAL_TYPE &&
              element.observations &&
              element.observations.includes('Calculando ETA'))
          }
        >
          <Table.Cell textAlign='center'>{element.orderCode}</Table.Cell>
          <Table.Cell textAlign='center'>{getOrderTypeName(element.orderType)}</Table.Cell>
          <Table.Cell textAlign='center' style={{'whiteSpace': 'nowrap'}}>
            <PartInfo partCode={element.partCode} partName={element.partName} />
            {this.renderSubstituteIcon()}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {element.date ? moment(element.date).format(fullDate) : ''}
          </Table.Cell>
          <Table.Cell textAlign='center'>{transportOptions[element.dealerTransport]}</Table.Cell>
          <Table.Cell textAlign='center'>{element.orderToProvider}</Table.Cell>
          <Table.Cell textAlign='center'>{transportOptions[element.transport]}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partQuantity}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderShowIcon(element.orderDetail, element.status)}
            {element.attendedQuantity || 0}
          </Table.Cell>
          <Agency order={element} />
          <Table.Cell textAlign='center'>{getOrderStatusName(element.status)}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.user ? element.user.toUpperCase() : ''}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.reference}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.orderType === SPECIAL_TYPE &&
            element.observations &&
            element.observations.includes('Calculando ETA') ?
              this.renderLoading() :
              element.etaStandard ?
                moment(element.etaStandard).format(shortDate) :
                null}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {element.etaUpdated ? moment(element.etaUpdated).format(shortDate) : null}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.orderRepair}</Table.Cell>
          <Table.Cell textAlign='center'>{element.comment}</Table.Cell>
          <Table.Cell textAlign='center'>{element.observations}</Table.Cell>
          <Table.Cell textAlign='center'>{element.vin}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderTrackingIcon(element)}
            <Comment order={element} />
            <DeleteIcon iconName='close' order={element} disabled={this.getDisabledStatus()} />
          </Table.Cell>
        </Table.Row>
        {this.renderBilling()}
        {this.renderSubstituteDetail()}
      </React.Fragment>
    );
  }
}

const {deleteDealerOrder, selectOrderForTrackingSchedule} = Actions;

export default connect(null, {
  deleteDealerOrder,
  selectOrderForTrackingSchedule,
})(OrderInfo);
